







































































import { Component, Vue } from "vue-property-decorator";
import ProjectManagerTableItem from "../viewmodels/project-manager-table-item";
import ProjectManagerSelect from "../templates/ProjectManagerSelect.vue";
import ProjectWorkerTableItem from "../viewmodels/project-worker-table-item";
import ProjectWorkerTable from "../components/project/ProjectWorkerTable.vue";
import ProjectMemberCardList from "@/components/project/ProjectMemberCardList.vue";
import ProjectMemberCard from "../components/project/ProjectMemberCard.vue";
import ProjectMemberCardViewModel from "@/viewmodels/project-member-card";
import ProjectWorkerTableItemDecorator from "../decorators/project-worker-table-item-decorator";
import ProjectManagerTableItemDecorator from "../decorators/project-manager-table-item-decorator";

import { ProjectManagerInteractor } from "@/interactors/project-manager-interactor";
import { VuexProjectManagerPresenter } from "@/presenters/project-manager-presenter";
import ProjectManagerApi from "../api/gateways/project-manager-api";

import { ProjectWorkerInteractor } from "@/interactors/project-worker-interactor";
import { VuexProjectWorkerPresenter } from "@/presenters/project-worker-presenter";
import ProjectWorkerApi from "../api/gateways/project-worker-api";
import ProjectManager from "../entities/project-manager";
import ProjectWorker from "../entities/project-worker";

type Mode = "show" | "edit" | "manager-assignment" | "worker-assignment";

@Component({
  components: {
    ProjectMemberCardList,
    ProjectMemberCard,
    ProjectManagerSelect,
    ProjectWorkerTable
  }
})
export default class ProjectMemberModal extends Vue {
  /* Modal */

  public show() {
    this.mode = "show";
    (this.$refs.modal as any).show();
  }

  public hide() {
    (this.$refs.modal as any).hide();
  }

  /* Mode */

  mode: Mode = "show";

  get showMode(): boolean {
    return this.mode === "show";
  }

  get editMode(): boolean {
    return this.mode === "edit";
  }

  get managerAssignmentMode(): boolean {
    return this.mode === "manager-assignment";
  }

  get workerAssignmentMode(): boolean {
    return this.mode === "worker-assignment";
  }

  private get permissions(): string[] {
    return this.$store.getters.permissions;
  }

  get editable(): boolean {
    return this.permissions.includes("service/project_read");
  }

  toShowMode() {
    this.mode = "show";
  }

  toEditMode() {
    this.mode = "edit";
  }

  toManagerAssignmentMode() {
    this.selectedMemberIds = [];
    this.mode = "manager-assignment";
  }

  toWorkerAssignmentMode() {
    this.selectedMemberIds = [];
    this.mode = "worker-assignment";
  }

  /* Project Member */

  selectedMemberIds: number[] = [];

  get managerTable() {
    return {
      selectedIds: this.selectedMemberIds,
      items: this.unassignedManagerItems
    };
  }

  get assignedManagerItems(): ProjectMemberCardViewModel[] {
    return this.assignedManagers.map(m => ({
      key: m.id,
      name: m.name,
      belongsTo: m.group.name,
      icon: m.icon,
      isHiddenInfo: m.isHiddenInfo
    }));
  }

  get unassignedManagerItems(): ProjectManagerTableItem[] {
    return this.unassignedManagers.map(ProjectManagerTableItemDecorator);
  }

  get workerTable() {
    return {
      selectedIds: this.selectedMemberIds,
      items: this.unassignedWorkerItems
    };
  }

  get assignedWorkerItems(): ProjectMemberCardViewModel[] {
    return this.assignedWorkers.map(m => ({
      key: m.id,
      name: m.name,
      belongsTo: m.group.name,
      icon: m.icon,
      isHiddenInfo: m.isHiddenInfo
    }));
  }

  get unassignedWorkerItems(): ProjectWorkerTableItem[] {
    return this.unassignedWorkers.map(ProjectWorkerTableItemDecorator);
  }

  // まとめて管理者にする
  async assignManagers() {
    await this.managerInteractor.assignAll(this.selectedMemberIds);
    this.mode = "edit";
  }

  async unassignManager(id: number) {
    this.managerInteractor.unassign(id);
  }

  // まとめて招待する
  async assignWorkers() {
    this.workerInteractor.assignAll(this.selectedMemberIds);
    this.mode = "edit";
  }

  async unassignWorker(id: number) {
    await this.workerInteractor.unassign(id);
  }

  get projectId(): number {
    return Number(this.$store.state.project.projectId);
  }

  /* Store */

  private get assignedManagers(): ProjectManager[] {
    return this.$store.getters["member/assigned-managers"];
  }

  private get unassignedManagers(): ProjectManager[] {
    return this.$store.getters["member/unassigned-managers"];
  }

  private get assignedWorkers(): ProjectWorker[] {
    return this.$store.getters["member/assigned-workers"];
  }

  private get unassignedWorkers(): ProjectWorker[] {
    return this.$store.getters["member/unassigned-workers"];
  }

  /* Model */

  private get managerInteractor() {
    return new ProjectManagerInteractor(
      new VuexProjectManagerPresenter(this.$store),
      new ProjectManagerApi(this.$store.getters.api, this.projectId)
    );
  }

  private get workerInteractor() {
    return new ProjectWorkerInteractor(
      new VuexProjectWorkerPresenter(this.$store),
      new ProjectWorkerApi(this.$store.getters.api, this.projectId)
    );
  }
}
